/**
 * 一个包装组件，根据内部placeholder内容自动调整宽度,常用于placeholder宽度不固定的输入框。
 * 它计算内容的宽度，并将其设置为包装元素的宽度。
 *
 * @component
 * @example
 * // 使用示例:
 * <AutoWidthInputWrapper paddingWidth={20} minWidth={200} placeholder={lang("输入文本"}>
 *   <input placeholder={lang("输入文本"} type="text" />
 * </AutoWidthInputWrapper>
 *
 * @param {React.ReactNode} children - 要包装的内容。
 * @param {string} wrapperClassName - 包装元素的类名。
 * @param {number} minWidth - 包装元素的最小宽度。
 * @param {string} placeholder - 输入框的占位文本。
 * @returns {JSX.Element} AutoWidthInputWrapper 组件。
 */
import React from 'react';
import { transformPx2Rem } from 'businessCommon/src/@utils';
import useTextWidth, { type TextStyle } from 'businessCommon/src/hooks/useTextWidth';
import { DEFAULT_TEXT_STYLE } from './constants';
import './index.scss';

interface IAutoWidthInputWrapperProps {
    children?: React.ReactNode;
    wrapperClassName?: string;
    wrapperStyle?: React.CSSProperties;
    placeholder: string;
    minWidth?: number;
    textStyles?: TextStyle;
}

const AutoWidthInputWrapper = (props: IAutoWidthInputWrapperProps) => {
    const { children, wrapperClassName, placeholder = '', minWidth, textStyles } = props || {};
    const width = useTextWidth(placeholder, textStyles || DEFAULT_TEXT_STYLE);

    return (
        <>
            <div
                className={`auto-width-input-wrapper ${wrapperClassName || ''}`}
                style={{
                    ...props.wrapperStyle,
                    ...(placeholder ? { width: transformPx2Rem(width) } : {}),
                    ...(minWidth ? { minWidth: transformPx2Rem(minWidth) } : {}),
                }}
            >
                {children}
            </div>
        </>
    );
};

export default AutoWidthInputWrapper;

export type { IAutoWidthInputWrapperProps, TextStyle };
